import '../App.css'
import React from 'react'
import { Fragment, useState, useEffect } from "react";
import Swal from 'sweetalert2';
import Footer from './Footer';
import Feature from './Feature';

import Principal from './Principal/Principal';

import ctg from '../ctg.json';
import data2 from '../data2.json';

import { Pagination } from 'flowbite-react';
import { CustomFlowbiteTheme } from 'flowbite-react';
import ModalProduct from './ModalProduct';


function Inicio(){

    const [registrados, setRegistrados] = useState([]);
    const [products, setProducts] = useState([]);
    const [categoriaIndex, setCategoriaIndex] = useState(1);
    const [categoriaName, setCategoriaName] = useState('');

    const toggleTab = (index,name) => {
        setCategoriaIndex(index);
        setCategoriaName(name)
    };

    const verificarCreador = '369';

    const showToast=()=>{
        if(verificarCreador=== localStorage.getItem('creadorKL')){
            console.log('')
        }else{
           const notification = document.querySelector('.toast-notification');
            notification.classList.add('show'); 
        }
    }
    const noShowToast=()=>{
        const notification = document.querySelector('.toast-notification');
        notification.classList.remove('show');        
    }
    const creador=()=>{
        window.open('https://keurylendof.vercel.app/', '_blank');
        localStorage.setItem('creadorKL', verificarCreador);
    }

    const agregarCarrito=(titulo, imagen, desc, precio)=>{

        Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Agregado al carrito',
            showConfirmButton: false,
            timer: 1500
        })

        const registro = {
            Title: `${titulo}`,
            Image: `${imagen}`,
            Quantity: 1,
            Price: precio
        }

        setRegistrados([registro, ...registrados])
       
    }

    const redireccionar=(id)=>{
        window.location.href = `/product/${id}`;
    }

    useEffect(()=>{
        const storeProductos = JSON.parse(localStorage.getItem('Registrados'));
        if(storeProductos){
          setRegistrados(storeProductos);
        }
      }
    ,[])

    useEffect(()=>{
        localStorage.setItem('Registrados', JSON.stringify(registrados))
    }
    ,[registrados])

    useEffect(()=>{

        setProducts(data2)

        setTimeout(showToast,10000)
    
    },[])

    const filtro = products.filter((dato)=>
        dato.category.toLowerCase().includes(categoriaName.toLowerCase()),
    )

    const [currentPage, setCurrentPage] = useState(1);

    const productsPerPage = 8;
    const lastIndex = currentPage * productsPerPage;
    const firstIndex = lastIndex - productsPerPage;
    const productsFinally = filtro.slice(firstIndex, lastIndex)
    const totalPage = Math.ceil(filtro.length / productsPerPage);

    const onPageChange = (page) => {
        setCurrentPage(page);
    };

    const customTheme = {
        pages: {
          selector: {
            base: "w-12 border border-gray-300 bg-white py-2 leading-tight text-gray-500 enabled:hover:bg-[#f66efb] enabled:hover:text-white",
            active: "bg-[#fb8cff] text-white hover:bg-[#f66efb]",
            disabled: "opacity-50 cursor-normal",
          }
        }
    }


      
 
    return (
        <>
            <div className="toast-notification">
                <article onClick={()=>creador()}>
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-user-code coder" width="30" height="30" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                        <path d="M6 21v-2a4 4 0 0 1 4 -4h3.5"></path>
                        <path d="M20 21l2 -2l-2 -2"></path>
                        <path d="M17 17l-2 2l2 2"></path>
                    </svg>
                    <h4 className="greeting-message">Developer: Keury Lendof. <span>Click Aqui</span> para mas detalles!</h4>  
                </article>
                
                <svg onClick={()=>noShowToast()} xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x close" width="25" height="25" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M18 6l-12 12"></path>
                    <path d="M6 6l12 12"></path>
                </svg>
            </div>

            <Principal num={registrados.length}/>

            <Feature/>

            <div className="filtro-products">

                {ctg.map((c)=>{
                    return(
                        <article
                            className={categoriaIndex === c.identificador ? "active" : ""}
                            onClick={() => toggleTab(c.identificador,c.link)}
                        >
                            {c.nombre}
                        </article>
                    )
                })}

            </div>

            <div class="container-products">

                {
                filtro.length === 0
                ?
                <div class="triangles">
                    <div class="tri invert"></div>
                    <div class="tri invert"></div>
                    <div class="tri"></div>
                    <div class="tri invert"></div>
                    <div class="tri invert"></div>
                    <div class="tri"></div>
                    <div class="tri invert"></div>
                    <div class="tri"></div>
                    <div class="tri invert"></div>
                </div>
                :
                productsFinally.map((d)=>{
                    return(
                        <div class="card">

                            <img onClick={()=>redireccionar(d.id)} src={d.image[0]} class="card-img-top" alt="..."/>

                            <div class="card-body">

                                <h5 class="card-title">{d.title}</h5>
                                <i class="fas fa-star star"></i>
                                <i class="fas fa-star star"></i>
                                <i class="fas fa-star star"></i>
                                <i class="fas fa-star star"></i>
                                <i class="fas fa-star star"></i>

                                <article>
                                    <h4 className='card-price'>RD$ {d.price}</h4>
                                    <i title='Agregar al carrito' onClick={()=> agregarCarrito(d.title, d.image[0], d.description, d.price)} class="fas fa-shopping-cart cart"></i>
                                </article>
                                
                            </div>

                        </div>
                    )
                })}

            </div>

            <div className='mt-8 mb-10 flex justify-center'>

                <Pagination
                    currentPage={currentPage}
                    onPageChange={onPageChange}
                    totalPages={totalPage}
                    previousLabel="<"
                    nextLabel=">"
                    theme={customTheme}
                    pageRangeDisplayed={2}
                />

            </div> 

            <Footer/>
        </>
    )
}

export default Inicio;
